// 获取系统语言
export const getLang = () => {
  let langLocal = localStorage.getItem('LANG') || 'zh_CN'
  const langList = ['en', 'zh_CN']
  if (!langList.includes(langLocal)) {
    langLocal = 'en'
  }
  return langLocal
}
export const getMenuTitle = (data: any, t: (key: string) => string) => {
  const langLocal = localStorage.getItem('LANG') || 'zh_CN'
  if (data.slug) {
    if (langLocal === 'zh_CN') {
      return data.title || ''
    }
    if (langLocal === 'en') {
      return data.titleEn || ''
    }
    // 其他语言需要匹配语言包
    const slug = data.slug.replace(/\./g, '_')
    const langKey = 'menus.' + slug
    if (t(langKey) !== langKey) {
      return t(langKey)
    }
  }
  return langLocal !== 'zh_CN' ? (data.titleEn || data.title) : data.title
}
